import Head from 'expo-router/head';

/**
 * Asks search engines not to index the page. The native implementation in
 * `NoIndexHead.tsx` renders nothing; see it for why the two are split.
 */
export function NoIndexHead() {
  return (
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
  );
}
